module.exports = __webpack_public_path__ + "img/3.48dea953.jpg";